import React, { useState } from 'react';
import ShareRow from '../../components/ShareRow/ShareRow';
import { shareChart, stopSharing } from '../../services/chartService';

const TEXT = {
  natal: {
    title: 'Share my chart',
    note: 'Your wheel, placements, full reading, and tarot spread if you pulled one, exactly as you see them here.',
    share: "Here's my birth chart and full reading on NowTarot:",
    inviteTitle: 'Invite a friend to draw theirs',
    inviteNote: 'Send a friend the free birth chart, so they can draw theirs and you can compare.',
    inviteUrl: '/birth-chart/',
    inviteText: "I just drew my birth chart on NowTarot. It's free, draw yours:",
  },
  synastry: {
    title: 'Share our compatibility',
    note: 'Both charts, the connections, and the full reading, exactly as you see them here.',
    share: 'Here is our birth chart compatibility reading on NowTarot:',
    inviteTitle: 'Invite someone to compare with you',
    inviteNote: 'Send the free compatibility tool to a friend, partner, or crush.',
    inviteUrl: '/birth-chart-compatibility/',
    inviteText: 'Compare our birth charts on NowTarot. It’s free:',
  },
};

const ChartShare = ({ session, hasAnswers, hasTarot = false, kind = 'natal' }) => {
  const text = TEXT[kind];
  const [includeQa, setIncludeQa] = useState(false);
  const [link, setLink] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const create = async () => {
    if (!session || busy) return;
    setBusy(true);
    setError('');
    try {
      setLink({ ...(await shareChart(session, { includeQa })), hasTarot });
    } catch (err) {
      setError(err.message || 'The share link could not be made.');
    } finally {
      setBusy(false);
    }
  };

  const stop = async () => {
    if (!link || busy) return;
    setBusy(true);
    setError('');
    try {
      await stopSharing(link.id);
      setLink(null);
    } catch (err) {
      setError(err.message || 'Sharing could not be stopped. Try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="chart-share-grid">
      <article className="chart-share-card">
        <h4>{text.title}</h4>
        <p className="birth-note">
          {text.note}
        </p>
        {!link ? (
          <>
            {hasAnswers && (
              <label className="birth-check">
                <input type="checkbox" checked={includeQa} onChange={(event) => setIncludeQa(event.target.checked)} />
                Include my questions and answers
              </label>
            )}
            <button type="button" className="birth-draw" onClick={create} disabled={!session || busy}>
              {busy ? 'Making your link…' : 'Create share link'}
            </button>
            {!session && <p className="birth-note">The link is ready once the reading finishes.</p>}
          </>
        ) : (
          <>
            <p className="chart-share-link">
              <a href={link.url} target="_blank" rel="noopener noreferrer">nowtarot.com{link.url}</a>
            </p>
            <ShareRow url={link.url} text={text.share} label="" compact />
            {hasTarot && !link.hasTarot && (
              <p className="birth-note">
                This link was made before you pulled your cards.{' '}
                <button type="button" className="birth-text" onClick={create} disabled={busy}>Make a new link with your cards</button>
              </p>
            )}
            <button type="button" className="birth-text" onClick={stop} disabled={busy}>Stop sharing</button>
          </>
        )}
        {error && <p className="birth-error">{error}</p>}
      </article>
      <article className="chart-share-card">
        <h4>{text.inviteTitle}</h4>
        <p className="birth-note">{text.inviteNote}</p>
        <ShareRow url={text.inviteUrl} text={text.inviteText} label="" compact />
      </article>
    </div>
  );
};

export default ChartShare;
